<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="TuxhornNemuxSMLV2_3d06_p20"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import Tuxhorn_Nemux_SML_V2_3d06_P20 from '@/device-products/Tuxhorn_Nemux_SML_V2_3d06_P20.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: Tuxhorn_Nemux_SML_V2_3d06_P20, deviceLabel: null, props: { leiterplattenCodierung: 0 } },
    ],
  }),
};
</script>

<style>

</style>
